export * from './about-us';
export * from './navbar';
export * from './banner';
export * from './claims';
export * from './faqs';
export * from './getStarted';
export * from './howWorks';
export * from './simpleBanner';
export * from './getStartedAlt';
export * from './containers';
